import { defineStore } from "pinia";

import { useToast } from "@/composables/useToast.ts";
import { usePrintersStore } from "@/store/printers/index.js";
import { IPagination } from "@/types/table.js";
import axios from "@/utils/axios.ts";

const { error } = useToast();

export const usePrepStore = defineStore("prepStore", {
  state: (): any => ({
    prepPrintersList: [],
    isPrepPrintersList: false,
  }),
  actions: {
    async fetchActualPrinter() {
      const printersStore = usePrintersStore();

      try {
        const { data } = await axios.get("/prep/printers/actual");
        printersStore.setPrintersList(data);
      }
      catch (errorResponse: any) {
        console.error(errorResponse);
        error(errorResponse.response?.data?.message || errorResponse.message);
      }
    },

    async listPrepPrinters(params?: IPagination) {
      this.isPrepPrintersList = true;
      await axios.get("/prep/printers", params as any)
        .then(({ data }) => {
          this.prepPrintersList = data;
        })
        .catch((errorResponse: any) => {
          error(errorResponse?.response?.data?.message || errorResponse?.message);
        })
        .finally(() => {
          this.isPrepPrintersList = false;
        });
    },
    async updateDefaultPrinter(printerId: number, labelId: number) {
      try {
        this.isPrepPrintersList = true;
        const response = await axios.patch(`/prep/printers/${printerId}/default`, {
          labelId,
        });
        await this.listPrepPrinters();
        return response;
      }
      catch (errorResponse: any) {
        console.error(errorResponse);
        error(errorResponse.response?.data?.message || errorResponse.message);
      }
      finally {
        this.isPrepPrintersList = false;
      }
    },
    createPrepPrinter(printer: any, callback: () => void) {
      this.isPrepPrintersList = true;
      return new Promise((resolve, reject) => {
        axios
          .post("/prep/printers", printer)
          .then((response) => {
            this.listPrepPrinters();
            callback && callback();
            resolve(response);
          })
          .catch((error) => reject(error))
          .finally(() => {
            this.isPrepPrintersList = false;
          });
      });
    },

  },
  getters: {},
});
